import { useCallback, useEffect } from 'react';
import {
    facebookLoginAppId as FB_APP_1_ID,
    facebookBusinessLoginAppId as FB_APP_2_ID
} from '../Config/facebookConfig';

export const facebookAppInit = async (appId) => {
    return new Promise((resolve, reject) => {
      try {

        window.FB.init({
          appId: appId,
          cookie: true,
          xfbml: true,
          version: 'v21.0',
          status: true,
          autoLogAppEvents: true,
        });
  
        // Verify initialization
        window.FB.getLoginStatus((response) => {
          if (response.status === 'unknown') {
            // SDK initialized but no auth status
            resolve({
              initialized: true,
              authenticated: false,
            });
          } else {
            // SDK initialized with auth status
            resolve({
              initialized: true,
              authenticated: response.status === 'connected',
              authResponse: response.authResponse,
            });
          }
        });
      } catch (error) {
        console.error('Facebook initialization error:', error);
        reject({
          initialized: false,
          error: error.message,
        });
      }
    });
  };

export const useFacebookSDK = (appNumber = 1) => {
    const switchFacebookApp = useCallback(async (appNumber) => {
        try {
            await facebookAppInit(appNumber === 1 ? FB_APP_1_ID : FB_APP_2_ID);
            return true;
        } catch (error) {
            console.error('Error switching Facebook app:', error);
            return false;
        }
    }, []);

    useEffect(() => {
        let isMounted = true;

        const initSDK = async () => {
            try {
                if (isMounted) {
                    await switchFacebookApp(appNumber);
                }
            } catch (error) {
                console.error('Error initializing Facebook SDK:', error);
            }
        };

        initSDK();

        return () => {
            isMounted = false;
        };
    }, [appNumber, switchFacebookApp]);

    return switchFacebookApp;
};
